import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import {
  RrhhTeamDetail,
  RrhhTeamsList,
  TeamMember,
} from 'src/app/models/rrhh.model';
import { TableHeader } from 'src/app/models/tableheader.model';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-rrhh-teams-tab',
  templateUrl: './rrhh-teams-tab.component.html',
  styleUrls: ['./rrhh-teams-tab.component.scss'],
})
export class RrhhTeamsTabComponent implements OnChanges {
  @Input() tableHeader: TableHeader[] = [];
  @Input() teamsList: RrhhTeamsList[] = [];
  @Input() teamDetail: RrhhTeamDetail | undefined;
  /** Id de team a expandir automáticamente (navegación desde Agentes). */
  @Input() expandTeamId: number | null = null;
  @Output() seeDetailTeam: EventEmitter<any> = new EventEmitter<any>();
  @Input() userCurrency: any;
  @Output() seeDialogRemoveTeam: EventEmitter<any> = new EventEmitter<any>();
  @Input() isLoadingTeamDetail!: boolean;
  /** Navegar al agente integrante (pestaña Agentes). */
  @Output() goToAgent = new EventEmitter<{ agentId: number; fullName: string }>();

  isDisabled = false; //⛔🤚 va a ser un campo por item

  readonly ICON_ARROW_RIGHT_UP = Constants.ICONS.ARROW_RIGHT_UP;

  buttonMoreActions: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.KEBAB,
    iconOnly: true,
  };

  buttonExpand: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.EXPAND_MORE,
    iconOnly: true,
  };

  buttonClosures: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Ver consolidado',
  };

  buttonModif: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Modificar',
    icon: Constants.ICONS.PENCIL_BLUE,
  };

  buttonRemoveTeam: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Baja QR',
    icon: Constants.ICONS.AGENT_REMOVE,
  };

  openRow = false; //🤚⛔ por item
  itemExpand: null | number = null;

  teamLeaderName: string = '';

  constructor(
    private readonly utils: UtilsService,
    private readonly router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.teamDetail) {
      if (this.teamDetail.members) {
        this.teamDetail.members.forEach((e) => {
          if (e.leader) {
            this.teamLeaderName = e.name + ' ' + e.lastname;
          }
        });
        this.teamDetail.members = [
          ...this.teamDetail.members.filter(
            (item) => !item.modificationStateDate
          ),
          ...this.teamDetail.members.filter(
            (item) => item.modificationStateDate
          ),
        ];
      }
    }

    if (
      (changes['expandTeamId'] || changes['teamsList']) &&
      this.expandTeamId != null &&
      this.teamsList?.length
    ) {
      const INDEX = this.teamsList.findIndex((t) => t.id === this.expandTeamId);
      if (INDEX >= 0 && this.itemExpand !== INDEX) {
        this.itemExpand = INDEX;
        this.seeDetailTeam.emit(this.teamsList[INDEX].id);
      }
    }
  }

  formatNumber(n: any): string {
    return this.utils.processNumberAddDotFormat(n);
  }

  onExpandItem(i: number) {
    this.itemExpand = this.itemExpand == i ? null : i;
    if (this.itemExpand != null) {
      this.seeDetailTeam.emit(this.teamsList[i].id);
    }
  }

  /** Emite navegación al agente integrante (matching por id, no por nombre). */
  onGoToAgent(member: TeamMember): void {
    if (!member?.id) {
      return;
    }
    this.goToAgent.emit({
      agentId: member.id,
      fullName: `${member.name} ${member.lastname}`,
    });
  }

  //Emite al padre para que el padre abra el dialogo de baja
  onButtonRemoveTeam(id: number) {
    const index = this.teamsList.findIndex((e) => e.id == id);
    if (this.teamsList[index].state == 'Activo') {
      this.seeDialogRemoveTeam.emit(id);
    }
  }

  //Validar si el elem. existe sino imprime un guión
  print(e: any) {
    return e ?? '-';
  }

  onModifTeam(status: string, index?: number) {
    let idTeam = '';
    if (index != undefined || index != null) {
      idTeam = this.teamsList[index].id.toString();
    } else {
      idTeam = this.teamDetail ? this.teamDetail.id.toString() : '';
    }

    if (status == 'Activo') {
      this.router.navigate(['/rrhh/edit-team/' + idTeam]);
    }
  }
}
